export default __webpack_public_path__ + "static/media/airbnb-icon.1389eca5.svg";